import { connect }          from 'react-redux';
import Errors               from '../../../errors';
import SuccessString        from '../../../success';
import { savePassword }     from './reset-password-dux';
import ResetPassword        from './reset-password.jsx';
import { dismissError }     from '../../../errors-dux';
import Locale               from '../../../locale';

export default connect(
    // mapStateToProps
    ( state, ownProps ) => {
      return {
            errors: Errors.getByType( state, Errors.ERROR_RESETPASSWORD_SETPASSWORD ),
            busy: state.resetPasswordData.busy,
            success: state.successData.done,
            passwordRules: state.clientData.passwordRules,
            passwordGuid: new URLSearchParams( ownProps.location.search ).get( 'k' ),
            passwordLabels: {
                isLowerCaseRequired: Locale.getString( state, 'common.passwordRules.lowercaseLabel' ),
                isUpperCaseRequired: Locale.getString( state, 'common.passwordRules.uppercaseLabel' ),
                isSpecialCharRequired: Locale.getString( state, 'common.passwordRules.specialCharacterLabel' ),
                isNumberRequired: Locale.getString( state, 'common.passwordRules.numberLabel' ),
                length: Locale.getString( state, 'common.passwordRules.lengthLabel', {
                    minLength: state.clientData.passwordRules.minLength,
                    maxLength: state.clientData.passwordRules.maxLength
                } )
            },
            successMessage: SuccessString.getByType( state, SuccessString.SUCCESS_RESET_PASSWORD ),
            backLabel: Locale.getString( state, 'common.button.backLabel' )
        };
    },
    // mapDispatchToProps
    {
        savePassword,
        dismissError
    }
)( ResetPassword );
